import { render, staticRenderFns } from "./ButtonDoneSorting.vue?vue&type=template&id=4fcb31a7&"
import script from "./ButtonDoneSorting.vue?vue&type=script&lang=js&"
export * from "./ButtonDoneSorting.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDoneSorting.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
